export default __webpack_public_path__ + "images/428c215b30f011d134a585281394e4c3-7316_NIYT_home_header_tablet_1067x470.jpg";